const timerColors = ["#ec1d57", "#ffa402", "#000"];

export const addDays = (date, days) => date.setDate(date.getDate() + days);

export const calculateProgress = (seconds) => (100 * seconds) / 600;

export const calculateTimerColor = (seconds) => {
  const progress = calculateProgress(seconds);

  if (progress <= 10) {
    return timerColors[0];
  } else if (progress <= 50) {
    return timerColors[1];
  }

  return timerColors[2];
};

export const getTimeLeft = (reservedUntil, serverTime) => {
  const INITIAL_TIME = 0;

  if (reservedUntil) {
    const timeLeft = new Date(reservedUntil) - new Date(serverTime);
    const timeLeftInSeconds = Math.round(timeLeft / 1000);
    return timeLeftInSeconds;
  }

  return INITIAL_TIME;
};
